import { render, staticRenderFns } from "./CreateNewPassword.vue?vue&type=template&id=1893e5f8&scoped=true&"
import script from "./CreateNewPassword.vue?vue&type=script&lang=js&"
export * from "./CreateNewPassword.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewPassword.vue?vue&type=style&index=0&id=1893e5f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1893e5f8",
  null
  
)

export default component.exports